import type {Component} from 'grapesjs';
import type {PrimaryConfigOptions} from '../index';

interface InfoBoxProps {
  type: string;
  component?: Component;
  class: string;
  content: string;
  isVisible?: ((editor: any, component: Component) => boolean) | boolean;
}

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType(window.PMW.emails.styles.ID_INFO_BOX, {
    create(data: any) {
      const props = data.props as InfoBoxProps;
      props.component = props.component ?? editor.getSelected();
      let isVisible = true;

      if (Object.prototype.hasOwnProperty.call(props, 'isVisible') && props.isVisible !== undefined) {
        if (typeof props.isVisible === 'function') {
          if (props.component) {
            isVisible = props.isVisible(editor, props.component);
          }
        } else {
          isVisible = props.isVisible;
        }

        // hide parent container to avoid redundant margin
        if (!isVisible) {
          $(`.gjs-sm-${props.type}`).addClass('_hidden');
        }
      }

      const infoClass = props.class || '';
      const container = document.createElement('div');
      const visibilityClass = isVisible ? '' : '_hidden';

      container.className = `${props.type} info-wrapper ${infoClass} ${visibilityClass}`;
      container.innerHTML = `<div class="info-box">
                    <div class="body-md-regular info-message">
                        ${props.content}
                    </div>
                </div>`;

      return container;
    },
  });
};
